import { DataSource } from "@/datasources/consulte-grid";
import { PatHistoricoBemModel } from "@/models/patrimonio/pathistoricobem/pathistoricobem.model";
import PatHistoricoBemService from "@/services/patrimonio/pathistoricobem/pathistoricobem.service";

export default class PatHistoricoBemDataSource extends DataSource<PatHistoricoBemModel> {
 private patBemId: number = 0;

 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: PatHistoricoBemModel[]) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<PatHistoricoBemModel>())
 }

 setPatBemId(patBemId: number) {
  this.patBemId = patBemId;
 }

 clear() {
  this.pageNumber = 0;
  this.rowsPageCount = 0;
  this.totalRowCount = 0;
  this.rows = [];
 }

 async load() : Promise<any> {
  if (!this.patBemId) {
   this.clear();
   return super.load();
  }

  const result = ((await PatHistoricoBemService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters, this.patBemId)).data as any) as DataSource<PatHistoricoBemModel>;
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = (result.rows ?? []).sort((a: PatHistoricoBemModel, b: PatHistoricoBemModel) => {
   const dataA = a.data ? new Date(a.data).getTime() : 0;
   const dataB = b.data ? new Date(b.data).getTime() : 0;

   return dataA - dataB;
  });
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
